import React from 'react';
import { useDarkMode } from '../../context/DarkModeContext';
const levels: Record<number, {
  label: string;
  lightColor: string;
  darkColor: string;
}> = {
  1: {
    label: 'Mild',
    lightColor: 'bg-sky-100 text-sky-700',
    darkColor: 'bg-sky-900/40 text-sky-300'
  },
  2: {
    label: 'Warm',
    lightColor: 'bg-amber-100 text-amber-700',
    darkColor: 'bg-amber-900/40 text-amber-300'
  },
  3: {
    label: 'Hot',
    lightColor: 'bg-orange-100 text-orange-700',
    darkColor: 'bg-orange-900/40 text-orange-300'
  },
  4: {
    label: 'Steamy',
    lightColor: 'bg-rose-100 text-rose-700',
    darkColor: 'bg-rose-900/40 text-rose-300'
  },
  5: {
    label: 'Scorching',
    lightColor: 'bg-red-100 text-red-700',
    darkColor: 'bg-red-900/40 text-red-300'
  }
};
interface SpiceLevelIndicatorProps {
  level: number;
}
export const SpiceLevelIndicator: React.FC<SpiceLevelIndicatorProps> = ({
  level
}) => {
  const {
    darkMode
  } = useDarkMode();
  if (level <= 0 || !levels[level]) return null;
  const {
    label,
    lightColor,
    darkColor
  } = levels[level];
  return <div className="flex items-center" data-id="element-6981" data-mp="3q3ly149xyygj">
      <span className={`text-sm mr-2 ${darkMode ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-6982" data-mp="3q2kq38o82s31">
        Spice Level:
      </span>
      <span className={`inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full font-medium ${darkMode ? darkColor : lightColor}`} data-id="element-6983" data-mp="3g5zjiiwk18x3">
        🔥 {label}
      </span>
    </div>;
};